import { Delete, Edit } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useState } from "react";
import EditChecklistItem from "./EditChecklistItem";
import useDeleteOrganizationProposalChecklistItem from "hooks/organization/useDeleteOrganizationProposalChecklistItem";
import ActionConfirmDialog from "components/ActionConfirmDialog/ActionConfirmDialog";

interface ChecklistItemItemProps {
  item: {
    id: string;
    name: string;
  };
}

export default function ChecklistItemItem({ item }: ChecklistItemItemProps) {
  const [isEditing, setIsEditing] = useState(false);
  const [deleteChecklistItem] = useDeleteOrganizationProposalChecklistItem();
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleDeleteConfirm = async () => {
    await deleteChecklistItem({
      variables: {
        id: item.id,
      },
    });
    setDialogOpen(false);
  };

  const handleDeleteCancel = () => {
    setDialogOpen(false);
  };

  return (
    <>
      {isEditing ? (
        <EditChecklistItem item={item} onCancel={() => setIsEditing(false)} />
      ) : (
        <MDBox sx={{ padding: "8px", borderBottom: "1px solid #eee" }}>
          <MDBox display="flex" justifyContent="space-between" alignItems="center">
            <MDTypography variant="body2" fontWeight="regular">
              {item.name}
            </MDTypography>
            <MDBox>
              <IconButton color="info" size="small" onClick={() => setIsEditing(true)}>
                <Edit fontSize="small" />
              </IconButton>
              <IconButton color="error" size="small" onClick={() => setDialogOpen(true)}>
                <Delete fontSize="small" />
              </IconButton>
            </MDBox>
          </MDBox>
        </MDBox>
      )}
      <ActionConfirmDialog
        open={dialogOpen}
        setOpen={setDialogOpen}
        title="Delete Checklist Item"
        content={`Are you sure you want to delete "${item.name}"?`}
        handleAccept={handleDeleteConfirm}
        handleCancel={handleDeleteCancel}
      />
    </>
  );
}
